import { FieldLayout, LabelPosition } from '@websential/cosmic-v20';
import React, { useEffect, useState } from 'react'

import { Calendar } from 'primereact/calendar';
import { Grid } from '@mui/material';

interface IPayPeriodPaymentDate {
    payPeriodPaymentDate: any;
    setPayPeriodPaymentDate: (value: any) => void;
}
export const PayPeriodPaymentDateComponent: React.FC<IPayPeriodPaymentDate> = ({ payPeriodPaymentDate, setPayPeriodPaymentDate }) => {
    const [date, setDate] = useState<any>(null)

    useEffect(() => {
        if (payPeriodPaymentDate && payPeriodPaymentDate !== null) {
            setDate(payPeriodPaymentDate)
        }
    }, [payPeriodPaymentDate])

    const onPayPeriodPaymentDateChnageHandler = (e: any) => {
        setDate(e.value)
        setPayPeriodPaymentDate(e.value)
    }
    return (
        <Grid>
            <FieldLayout testId={"undefined"} label="Payment Date" labelColumns={4} fieldColumns={8} labelPosition={LabelPosition.Left} isRequired={true}>
                <Calendar
                    id="date"
                    value={date}
                    showIcon
                    className="calender"
                    style={{ height: "2.6rem", margin: "8px 0px 4px 0px", width: "100%" }}
                    onChange={onPayPeriodPaymentDateChnageHandler}
                    dateFormat="M dd, yy"
                    showButtonBar
                />
            </FieldLayout>
        </Grid>
    );
}
